import React, { useState } from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import Services from './components/Services';
import Contact from './pages/Contact';
import Career from './pages/Career';
import Blog from './pages/Blog';
import CustomerReview from './pages/CustomerReview';
import AboutGyaniraj from './pages/AboutGyaniraj';
import FlexPrinting from './pages/FlexPrinting';
import AdvertisePrinting from './pages/AdvertisePrinting';
import GarmentsPrinting from './pages/GarmentsPrinting';
import BoxBagPrinting from './pages/BoxBagPrinting';
import MulticolorPrinting from './pages/MulticolorPrinting';
import CardsPrinting from './pages/CardsPrinting';
import BusinessPrinting from './pages/BusinessPrinting';
import OtherPrinting from './pages/OtherPrinting';
import CtaSection from './components/CtaSection';
import Footer from './components/Footer';
import './styles/global/App.css';

function App() {
  const [currentPage, setCurrentPage] = useState('home');

  const renderPage = () => {
    switch (currentPage) {
      case 'career':
        return <Career />;
      case 'blog':
        return <Blog />;
      case 'reviews':
        return <CustomerReview />;
      case 'about':
        return <AboutGyaniraj />;
      case 'contact':
        return <Contact />;
      case 'services':
        return <FlexPrinting />;
      case 'advertise':
        return <AdvertisePrinting />;
      case 'garments':
        return <GarmentsPrinting />;
      case 'boxbag':
        return <BoxBagPrinting />;
      case 'multicolor':
        return <MulticolorPrinting />;
      case 'cards':
        return <CardsPrinting />;
      case 'business':
        return <BusinessPrinting />;
      case 'other':
        return <OtherPrinting />;
      default:
        return (
          <>
            <Hero />

            <Services setCurrentPage={setCurrentPage} />
          </>
        );
    }
  };

  return (
    <div className="App">
      <Header setCurrentPage={setCurrentPage} />
      <main style={{ marginTop: '80px' }}>
        {renderPage()}
        <CtaSection />
      </main>
      <Footer />
    </div>
  );
}

export default App;
